import { toast } from "react-toastify";
import { getProjects } from "common-lib";
import { TutorialKey } from "../context/TutorialContext";

export const TUTORIAL_OPTIONS: { key: TutorialKey; label: string; path: string }[] = [
  { key: "inspection-project", label: "검사 프로젝트 튜토리얼", path: "/main/projects" },
  { key: "cls-project", label: "분류 프로젝트 튜토리얼", path: "/main/projects" },
  { key: "analysis-project", label: "분석 프로젝트 튜토리얼", path: "/main/project/340/analysis" },
  { key: "inspection-status", label: "검사현황 튜토리얼", path: "/main/status" },
  { key: "report-generation", label: "리포트 튜토리얼", path: "" },
];

export async function resolveTutorialPath(key: TutorialKey, path: string): Promise<string | null> {
  if (key !== "report-generation") return path;

  const response = await getProjects();
  const projects: { id: number }[] = response?.projects?.data ?? [];
  if (projects.length === 0) {
    toast.warn("프로젝트가 없어 리포트 튜토리얼을 시작할 수 없습니다. 먼저 프로젝트를 생성해주세요.");
    return null;
  }
  const oldestId = projects.reduce((min, project) => Math.min(min, project.id), Infinity);
  return `/main/project/${oldestId}`;
}
